import { useState, useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import axios from "axios";
import { useSnackbar } from "notistack";
import { withPather } from "react-pather";
import { TagsSelect, TagCreationButton } from "../../general";

const Tags = ({ pather, advanced, setAdvancedSafe }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [tags, setTags] = useState([]);

  const [loading, setLoading] = useState(false);

  // Helpers
  const selectedTags = advanced.tags;
  const setSelectedTags = (_tags) => {
    setAdvancedSafe({ tags: _tags });
  };
  //

  const onSelectionChange = (event, _tags) => {
    setSelectedTags(_tags);
  };

  const fetchTags = () => {
    setLoading(true);
    axios
      .get(pather.back.Tags.list)
      .then((response) => {
        const data = response.data;
        setTags(data.tags);
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar("Some error occurred during tags fetching", {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSuccessfulCreation = (tag) => {
    setTags((currentTags) => [...currentTags, tag]);
    setSelectedTags([...selectedTags, tag]);
  };

  useEffect(() => {
    fetchTags();
  }, []);

  return (
    <>
      {loading ? (
        <CircularProgress size={30} />
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
          }}
        >
          <Box>
            <TagsSelect
              tags={tags}
              selectedTags={selectedTags}
              onSelectionChange={onSelectionChange}
            />
          </Box>
          <TagCreationButton onSuccess={onSuccessfulCreation} />
        </Box>
      )}
    </>
  );
};

export default withPather()(Tags);
